import React, { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../css/header.css';
import '../css/headerSl.css';
import '../css/headerSt.css';
import '../css/headerSm.css';
import { useAppShellCustomState } from '../../../../context-module/context-configuration/auth-provider/appShell/appShellProvider';
import { CrossIcon, HamburgerIcon } from '../../../../assets-module/asset-configuration/icon/iconExporter/iconExporter';
import HeaderDropDown from './headerDropDown';
import { useMediaQuery } from '../../../../context-module/context-configuration/auth-provider/mediaProvider/mediaProvider';
import logoSdx from "../../../../assets-module/asset-configuration/image/sodexs_logo_red.svg"
import { useCmsGlobals } from '../../../../context-module/context-configuration/auth-provider/appShell/appShellGlobal/appUseGlData';

const Header: FC = () => {
  const isMobile = useMediaQuery('(max-width: 850px)');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { header } = useAppShellCustomState();
  const location = useLocation();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const { globals } = useCmsGlobals()

  const cmsHeader = globals?.header ?? null;

  const isActivePath = (path: string) => location.pathname === path || location.pathname.startsWith(path + '/');

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  if (!header.visible) return null;

  const navigateOrScrollTop = (pathUrl: string) => {
    if (location.pathname === pathUrl) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    } else {
      navigate(pathUrl);
    }

    setIsMenuOpen(false);
  };


  const onClickLogo = () => {
    navigateOrScrollTop('/product');
  };

  const onClickNavigateMenu = (pathUrl: string) => {
    navigateOrScrollTop(pathUrl);
  };

  const onClickCTMenu = (pathUrl: string) => {
    navigateOrScrollTop(pathUrl);
  };

  return (
    <header className={`scl--style-header ${isScrolled ? 'is-scrolled' : 'is-top'}`}>
      <div className='scl--cnt-sty-head-box'>
        {/* ================= Logo ================= */}
        {cmsHeader?.logo?.visible && (
          <div //NOSONAR
            className="scl--style-logo-link"
            onClick={onClickLogo}
          >
            {cmsHeader?.logo?.visible && cmsHeader?.logo?.image?.src ?
              <img
                src={cmsHeader?.logo?.image?.src}
                alt={header.title}
              />
              :
              <img
                src={logoSdx}
                alt={header.title}
              />
            }
          </div>
        )}

        {/* =====cmsHeader?.title=========== Navigation ================= */}
        {cmsHeader?.navigation?.visible && !isMobile && (
          <nav className="scl--style-navigation">
            {cmsHeader?.navigation?.items
              .filter((item: any) => item?.visible)
              .map((item: any) => (
                <span //NOSONAR
                  key={item.key}
                  className={`scl--style-nav-item ${isActivePath(item.path) ? 'scl--style-active' : ''
                    }`}
                  onClick={() => onClickNavigateMenu(item?.path)}
                >
                  {item?.label}
                </span>
              ))}
          </nav>
        )}

        {/* ================= CTA ================= */}
        {cmsHeader?.cta?.visible && (
          <div className='scl--resp-hea-ext-btn-stl'>
            {!isMobile &&
              <div //NOSONAR
                className={`scl--style-contact-button ${isActivePath(header.cta.path) ? /* istanbul ignore next */ 'active' : ''
                  }`}
                onClick={() => onClickCTMenu(header.cta.path)}
              >
                <span
                  className="scl--style-button-text"
                >
                  {cmsHeader?.cta?.content?.label}
                </span>
              </div>
            }

            {isMobile && (
              <div className="scl--dd-menu-hea-stl-cont">
                <div className="scl--dmhsc-ico-stl-bo">
                  <button onClick={() => setIsMenuOpen(prev => !prev)}>
                    {isMenuOpen ?
                      <CrossIcon />
                      :
                      <HamburgerIcon />
                    }

                  </button>
                </div>

                <div
                  className={`scl--hdd-cont-stl-bo ${isMenuOpen ? 'is-open' : 'is-closed'
                    }`}
                >
                  <HeaderDropDown setIsMenuOpen={setIsMenuOpen} />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
